import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { CreateChancel, CustomizedSwitch, InputMain } from 'components';
import { FindLoad, FindSuccessItem, Images, useModal } from 'utils';
import { httpRequestsOnSuccessActions, systemActions } from 'store';
import { clearHouseTypeEnums } from '../constants';

// const ACTION_TYPE = 'CONNECT_AVAILITY';
const ACTION_TYPE = 'CONNECT_INTEGRATION';
export const ConnectAvaility = () => {
    const { close } = useModal();
    const { handleSubmit, control } = useForm();
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const [sftpPollingEnabled, setSftpPollingEnabled] = useState(false);
    const [showPassword, setShowPassword] = useState({
        password: false,
    });

    useEffect(() => {
        if (success) {
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
        }
    }, [success]);

    const handleCreate = (data) => {
        dispatch(
            systemActions.connectIntegration({
                availity: {
                    ...data,
                    sftpPollingEnabled: sftpPollingEnabled,
                },
                clearinghouseType: clearHouseTypeEnums.AVAILITY,
            })
        );
    };

    const toggleShowPassword = (field) => {
        setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
    };

    return (
        <div style={{ width: 400 }}>
            <div className="office-ally-header">
                <div className="office-ally-header-icons">
                    <div>
                        <img src={Images.logoSmall} alt="" />
                    </div>
                    <img src={Images.compareArrows} alt="arrow" />
                    <div>
                        <img src={Images.availity} alt="" />
                    </div>
                </div>
                <p>Connect to Availity</p>
            </div>
            <form onSubmit={handleSubmit(handleCreate)}>
                <p className="integration-title-text" style={{ marginBottom: 16 }}>SFTP Credentials</p>

                <div className="flex-align-center" style={{ gap: 16 }}>
                    <div className="full-width">
                        <InputMain
                            label={'Username*'}
                            customClass={true}
                            variant="outlined"
                            name="username"
                            type="text"
                            control={control}
                            placeholder="Enter username"
                            rules={{
                                required: 'Username is required.',
                            }}
                        />
                        <InputMain
                            label={'Password*'}
                            customClass={true}
                            variant="outlined"
                            name="password"
                            type="password"
                            showPassword={showPassword?.password}
                            control={control}
                            placeholder="Enter password"
                            rules={{
                                required: 'Password is required.',
                            }}
                            onClickIconEnd={() => toggleShowPassword('password')}
                        />
                        {/*    <InputMain*/}
                        {/*        label={'Sender Name'}*/}
                        {/*        customClass={true}*/}
                        {/*        variant="outlined"*/}
                        {/*        name="senderName"*/}
                        {/*        type="text"*/}
                        {/*        control={control}*/}
                        {/*        placeholder="Enter Sender Name"*/}
                        {/*        // rules={{*/}
                        {/*        //     required: 'Sender Name is required.',*/}
                        {/*        // }}*/}
                        {/*    />*/}
                        {/*    <InputMain*/}
                        {/*        label={'Sender Id'}*/}
                        {/*        customClass={true}*/}
                        {/*        variant="outlined"*/}
                        {/*        name="senderId"*/}
                        {/*        type="text"*/}
                        {/*        control={control}*/}
                        {/*        placeholder="Enter Sender Id"*/}
                        {/*        // rules={{*/}
                        {/*        //     required: 'Sender Id is required.',*/}
                        {/*        // }}*/}
                        {/*    />*/}
                        {/*</div>*/}

                        {/*<div className="full-width">*/}
                        {/*    <InputMain*/}
                        {/*        label={'Receiver Name'}*/}
                        {/*        customClass={true}*/}
                        {/*        variant="outlined"*/}
                        {/*        name="receiverName"*/}
                        {/*        type="text"*/}
                        {/*        control={control}*/}
                        {/*        placeholder="Enter Receiver Name"*/}
                        {/*        // rules={{*/}
                        {/*        //     required: 'Receiver Name is required.',*/}
                        {/*        // }}*/}
                        {/*    />*/}
                        {/*    <InputMain*/}
                        {/*        label={'Receiver Id'}*/}
                        {/*        customClass={true}*/}
                        {/*        variant="outlined"*/}
                        {/*        name="receiverId"*/}
                        {/*        type="text"*/}
                        {/*        control={control}*/}
                        {/*        placeholder="Enter Receiver Id"*/}
                        {/*        // rules={{*/}
                        {/*        //     required: 'Receiver Id is required.',*/}
                        {/*        // }}*/}
                        {/*    />*/}
                        {/*    <InputMain*/}
                        {/*        label={'Application'}*/}
                        {/*        customClass={true}*/}
                        {/*        variant="outlined"*/}
                        {/*        name="application"*/}
                        {/*        type="text"*/}
                        {/*        control={control}*/}
                        {/*        placeholder="Enter Application"*/}
                        {/*        // rules={{*/}
                        {/*        //     required: 'Application is required.',*/}
                        {/*        // }}*/}
                        {/*    />*/}
                        {/*    <InputMain*/}
                        {/*        label={'Api Kay'}*/}
                        {/*        customClass={true}*/}
                        {/*        variant="outlined"*/}
                        {/*        name="apiKay"*/}
                        {/*        type="text"*/}
                        {/*        control={control}*/}
                        {/*        placeholder="Enter Api Kay"*/}
                        {/*        // rules={{*/}
                        {/*        //     required: 'Api Kay is required.',*/}
                        {/*        // }}*/}
                        {/*    />*/}
                    </div>
                </div>

                <div className="flex-align-start" style={{ gap: 4, marginBottom: 12 }}>
                    <img src={Images.toolInfoIcon} alt="info" style={{ marginTop: 3 }} />
                    <p className="files-sftp-folder">
                        Files in the configured SFTP folder may be processed, moved, archived, or deleted automatically by TherapyLake.
                    </p>
                    <CustomizedSwitch checked={sftpPollingEnabled} handleClick={() => setSftpPollingEnabled(!sftpPollingEnabled)} />
                </div>

                <div style={{ marginTop: 24 }}>
                    <CreateChancel
                        type="submit"
                        loader={!!loader.length}
                        create={'Connect'}
                        chancel={'Cancel'}
                        onClose={close}
                        buttonWidth={'100%'}
                    />
                </div>
            </form>
        </div>
    );
};
